import { lists } from "../../utils"
import { Typography } from "@mui/material"
import useStyles from "./style"

const DateToday = () => {
  const classes = useStyles()
  const date = new Date()
  const day = date.getDate()
  const month = date.getMonth()
  const weekDay = date.getDay()

  return (
    <Typography className={classes.date}>
      {`${lists.date.days[weekDay]} ${day} de ${lists.date.months[month]}`}
    </Typography>
  )
}

export default DateToday
